import React, { Fragment } from 'react'
import '../style.css'

import { Link } from 'react-router-dom'
import { Row, Col, Button, Glyphicon, Label } from 'react-bootstrap'

const ResourcePost = (props) => {
  let createdBy = `${props.currentPost.created_by.first_name} ${props.currentPost.created_by.last_name}`
  let createdById = props.currentPost.created_by.id

  let postedDate = props.currentPost.created_date.split("T")[0].split("-")
  let formatedDate = `${postedDate[1]}-${postedDate[2]}-${postedDate[0]}`

  return (
    <Fragment>
      <Col xsHidden smHidden mdHidden lg={1} xl={1}></Col>
      <Col xs={12} sm={12} md={12} lg={10} xl={10} id="post-content">
        <Row>
          <Col md={4}>
            <div>
              <Link to="/resource-posts">
                <Button className="back-button">
                  <Glyphicon glyph="arrow-left" /> Back
                  </Button>
                </Link>
              </div>
            </Col>
        <Col md={5}>
            <h4>
              {props.currentPost.name}
            </h4>
            {props.currentPost.tags.map(tag => {
              return <span key={tag.id} style={{fontSize:"14pt"}}><Label bsStyle="default">#{tag.name}</Label>&nbsp;&nbsp;</span>
            })}
        </Col>
        <Col md={3}>
          <div>
            <div>Posted on: {formatedDate}</div>
            <div>Posted by: <span
              className={createdById === props.currentUser.pk ? "current-user" : null}
              >
              {createdBy}
            </span></div>
            <div>Views: {props.currentPost.views}</div>
          </div>
        </Col>
      </Row>
      <Row>
        <Button onClick={props.toggleEditable} className="back-button">
          <Glyphicon glyph="pencil" /> Edit Post
        </Button>

      </Row>
        <hr/>
        <div
          className="post-content-div"
          dangerouslySetInnerHTML={{__html: props.currentPost.text}}
        >
        </div>
        <hr/>
        {props.currentPost.documents.length > 0 ?
          <h4>Attached Documents</h4>
          :
          null
        }
        {props.currentPost.documents.map(doc => {
          return (
            <div className="document-button" key={doc.id}>
              <Button onClick={() => props.handleDocumentClick(doc.document)}>
                {doc.name}
              </Button>
            </div>
          )
        })
        }
      </Col>
    </Fragment>
  )
}

export default ResourcePost



// WEBPACK FOOTER //
// ./src/routes/resource-posts_post/components/ResourcePost.js